import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToFront = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 14.15L22.5 9.15V23.45C22.5 23.8833 22.6417 24.2417 22.925 24.525C23.2083 24.8083 23.5667 24.95 24 24.95C24.4333 24.95 24.7917 24.8083 25.075 24.525C25.3583 24.2417 25.5 23.8833 25.5 23.45V9.1L30.55 14.1C30.85 14.4 31.2 14.55 31.6 14.55C32 14.55 32.35 14.4 32.65 14.1C32.95 13.8 33.1 13.45 33.1 13.05C33.1 12.65 32.9667 12.3167 32.7 12.05L25.1 4.45C24.9333 4.28333 24.7667 4.16667 24.6 4.1C24.4333 4.03333 24.25 4 24.05 4C23.85 4 23.6667 4.03333 23.5 4.1C23.3333 4.16667 23.1667 4.28333 23 4.45L15.45 12C15.15 12.3 15 12.65 15 13.05C15 13.45 15.15 13.8 15.45 14.1C15.75 14.4 16.1 14.55 16.5 14.55C16.9 14.55 17.2333 14.4167 17.5 14.15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.16608 30.814C5.54496 30.0773 6.44932 29.7872 7.18603 30.1661L23.7713 38.6957C23.9149 38.7695 24.0852 38.7695 24.2287 38.6957L40.814 30.1661C41.5507 29.7872 42.4551 30.0773 42.8339 30.814C43.2128 31.5507 42.9227 32.4551 42.186 32.8339L25.6007 41.3635C24.5961 41.8802 23.4039 41.8802 22.3993 41.3635L5.81399 32.8339C5.07728 32.4551 4.7872 31.5507 5.16608 30.814Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 20.001V16.6275L5.81398 23.6661C5.31418 23.9231 5 24.438 5 25C5 25.562 5.31418 26.0769 5.81398 26.3339L22.3993 34.8635C23.4039 35.3802 24.5961 35.3802 25.6007 34.8635L42.186 26.3339C42.6858 26.0769 43 25.562 43 25C43 24.438 42.6858 23.9231 42.186 23.6661L28.5 16.6275V20.001L38.2202 25L24.2287 32.1957C24.0852 32.2695 23.9148 32.2695 23.7713 32.1957L9.77978 25L19.5 20.001Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M42.186 23.6661L28.5 16.6275V20.001L38.2202 25L24.2287 32.1957C24.0852 32.2695 23.9148 32.2695 23.7713 32.1957L9.77978 25L19.5 20.001V16.6275L5.81398 23.6661C5.31418 23.9231 5 24.438 5 25C5 25.562 5.31418 26.0769 5.81398 26.3339L22.3993 34.8635C23.4039 35.3802 24.5961 35.3802 25.6007 34.8635L42.186 26.3339C42.6858 26.0769 43 25.562 43 25C43 24.438 42.6858 23.9231 42.186 23.6661Z",
			fill: "currentColor"
		})
	]
});
export default SvgToFront;
